import type { Theme } from '@wds/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(({ spacing, palette, radius }: Theme) => ({
  forbiddenError: () => ({
    textAlign: 'center',
    backgroundColor: palette.background.main,
    display: 'flex',
    justifyContent: 'center',
    padding: 150,
  }),
  forbiddenErrorMessageWrapper: () => ({
    minWidth: 550,
    margin: spacing[1], // should be spacing 0
    position: 'unset',
  }),
  forbiddenErrorMessageContainer: () => ({
    padding: spacing[6],
    backgroundColor: palette.background.light,
    border: `1px solid ${palette.muted.main}`,
    borderRadius: radius.small,
    marginTop: spacing[4],
  }),
  forbiddenErrorLinksContainer: () => ({
    overflow: 'hidden',
    margin: spacing[4],
    position: 'relative',
  }),
  forbiddenErrorLinksList: () => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    listStyleType: 'none',
    marginLeft: -1,
  }),
  forbiddenErrorLinksListItem: () => ({
    flexGrow: 1,
    flexBasis: 'auto',
    textAlign: 'center',
    borderRight: '1px solid #ccc',
    backgroundColor: palette.background.light,

    '&:last-child': {
      borderRight: 'none',
    },
  }),
}));

export default useStyles;
